import React from 'react';

import { Divider, Stack } from '@mui/material';

import { SavedRouteAlertMetricType } from 'state/emailAlertsSlices';

import { AlertMetricField } from './AlertMetricField';
import { AlertResolutionEmailField } from './AlertResolutionEmailField';
import { AlertScheduleField } from './AlertScheduleField';

import styles from '../ManageAlerts.module.css';

interface AlertTriggersFieldProps {
  mode: 'view' | 'edit';
  metricThresholdLocked?: boolean;
  metricType: SavedRouteAlertMetricType;
  metricCriteria: number;
  typicalYearNum?: number | null;
  typicalMonthNum?: number | null;
  scheduleDayTypes: number[];
  scheduleDayHours: number[];
  hasResolutionEmail: boolean;
  onMetricCriteriaChange?: (value: number) => void;
  onTypicalYearChange?: (year: number | null) => void;
  onTypicalMonthChange?: (month: number | null) => void;
  onDayTypesChange?: (dayTypes: number[]) => void;
  onDayHoursChange?: (dayHours: number[]) => void;
  onResolutionEmailChange?: (checked: boolean) => void;
}

export function AlertTriggersField({
  mode,
  metricThresholdLocked,
  metricType,
  metricCriteria,
  typicalYearNum,
  typicalMonthNum,
  scheduleDayTypes,
  scheduleDayHours,
  hasResolutionEmail,
  onMetricCriteriaChange,
  onTypicalYearChange,
  onTypicalMonthChange,
  onDayTypesChange,
  onDayHoursChange,
  onResolutionEmailChange,
}: AlertTriggersFieldProps) {
  return (
    <Stack gap={1.5} className={styles.tabPanels} width="100%">
      <AlertMetricField
        mode={mode}
        metricThresholdLocked={metricThresholdLocked}
        metricType={metricType}
        metricCriteria={metricCriteria}
        typicalYearNum={typicalYearNum}
        typicalMonthNum={typicalMonthNum}
        onMetricCriteriaChange={onMetricCriteriaChange}
        onTypicalYearChange={onTypicalYearChange}
        onTypicalMonthChange={onTypicalMonthChange}
      />
      <Divider />
      <AlertScheduleField
        mode={mode}
        scheduleDayTypes={scheduleDayTypes}
        scheduleDayHours={scheduleDayHours}
        onDayTypesChange={onDayTypesChange}
        onDayHoursChange={onDayHoursChange}
      />
      <Divider />
      <AlertResolutionEmailField
        mode={mode}
        hasResolutionEmail={hasResolutionEmail}
        onChange={onResolutionEmailChange}
      />
    </Stack>
  );
}
